import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'
import Switch from '../../../../uiKit/Switch'

const styles = theme => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 20px 16px 20px',
        backgroundColor: '#fff',
        borderRadius: '10px',
        marginTop: '16px',
        boxShadow: '0px 0px 5.2px 2px #86868626',
        border: '1px solid #EBEBEB',
    },
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '16px',
        maxWidth: '705px',
    },
    title: {
        fontWeight: '700',
        fontSize: '16px',
        marginBottom: '4px',
        color: '#333333',
    },
    description: {
        fontSize: '14px',
        color: '#7a7a7a',
    },
})

const AIFeaturesToggle = ({ classes, enabled, onChange }) => {
    return (
        <div className={classes.container}>
            <div className={classes.iconContainer}>
                <img src="/images/platform/IconAiFeedback.svg" alt="AI Feedback icon" />
                <div className={classes.textContainer}>
                    <div className={classes.title}>{enabled ? 'Disable AI Chat Feedback' : 'Enable AI Chat Feedback'}</div>
                    <div className={classes.description}>
                        Turn this on to collect helpfulness feedback on chatbot responses using simple buttons. You can switch this off
                        anytime to disable feedback prompts from appearing in chats.
                    </div>
                </div>
            </div>
            <Switch checked={enabled} onChange={onChange} />
        </div>
    )
}

AIFeaturesToggle.propTypes = {
    classes: PropTypes.object.isRequired,
    enabled: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
}

export default withStyles(styles)(AIFeaturesToggle)
